import React, { useEffect, useState } from "react";
import AddNewItemsPage from "../../../../entities/DashboardPage/AccountingModule/AddNewItem";
import AuthService from "../../../../api/AuthService";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";

const AddNewItem = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [supplierList, setSupplierList] = useState();

  useEffect(() => {
    getSupplierList()
  }, [])

  const handleNewItem = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.AddNewItem(payload);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success")
        navigate("/dashboard/items")
      } else {
        setLoading(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <AddNewItemsPage handleData={handleNewItem} handleSupplierList={getSupplierList} supplierList={supplierList} loading={loading} />
  )

}

export default AddNewItem;
